<template>
  <div ref="container" class="notifications-list">
    {{ $t('labels.notification_list') }}
    <transition-group name="fadeRight" tag="div">
      <div class="notifications-list__day" v-for="(notifications, day, index) in byDates" :key="day">
        <div class="notifications-list__day--title">
          {{dayText(day)}}
          <div class="notifications-list__day--closeBtn el-icon-close" @click="deleteNotificationsByDay(day)"></div>
        </div>
        <transition-group name="fadeRight" tag="div">
          <notification v-for="notification of notifications" :notification="notification" :day="day"
                        :key="notification.getId()"></notification>
        </transition-group>
      </div>
    </transition-group>
  </div>
</template>

<script>
  import Notification from './Notification';
  import moment from 'moment'
  import {momentLang as lang} from '@/lang/index';

  export default {
    name: 'notifications-list',
    data () {
      return {
        loading: false
      }
    },
    components: {Notification},
    methods: {
      dayText (day) {
        let today = moment().locale(lang).format('YYYY-MM-DD')
        let yesterday = moment().locale(lang).subtract(1, 'day').format('YYYY-MM-DD')
        if (day === today) {
          return this.$t('labels.today')
        }
        if (day === yesterday) {
          return this.$t('labels.yesterday')
        }
        return moment(day).locale(lang).format('DD MMMM YYYY')
      },
      deleteNotificationsByDay (day) {
        this.$store.dispatch('notifications/deleteNotifications', {day})
      }
    },
    computed: {
      notifications () {
        return this.$store.state.notifications.notifications
      },
      byDates () {
        let list = {}
        for (let notificationId in this.notifications) {
          let notification = this.notifications[notificationId]
          let day = notification.getDate().format('YYYY-MM-DD')
          if (!list[day]) {
            list[day] = []
          }
          list[day].push(notification)
        }
        return list
      }
    }
  }
</script>

<style lang="scss">
  .notifications-list {
    width: 100%;
    padding-bottom: 10px;
    .app-notification {
      transition-duration: .4s;
      &.fadeRight-leave-active {
        width: 100%;
        position: absolute;
        .app-notification__closeBtn {
          display: none;
        }
        pointer-events: none;
      }
      &.fadeRight-move {
        transition-delay: .4s;
      }
    }
    &__day {
      position: relative;
      padding-top: 5px;
      width:100%;
      transition-duration: .4s;
      &.fadeRight-leave-active {
        position: absolute;
        pointer-events: none;
      }
      &.fadeRight-move {
        transition-delay: .4s;
      }
      &--title {
        padding-top: 10px;
        color: #909399;
        font-size: 12px;
      }
      &--closeBtn {
        cursor: pointer;
        position: absolute;
        right: -15px;
        padding: 10px;
        top: 8px;
      }
    }
  }
</style>